<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-loyalty-activations">

    <page-title :title="'Program lojalnościowy'" :back="true"></page-title>

    <loyalty-segment :value="'LoyaltyActivations'"></loyalty-segment>

    <div v-if="activations.length">
      <div v-for="(item,index) in activations" :key="index">
        <item-loyalty-activation
            :index="index"
            :slug="item.slug"
            :title="item.title"
            :image="item.image"
            :started_at="item.started_at"
            :ended_at="item.ended_at"
            :url_to_legal="item.url_to_legal"
            :url_to_conditions="item.url_to_conditions">
        </item-loyalty-activation>
      </div>
    </div>
    <div v-else>
      <p class="text-center mt-20">Brak aktywacji</p>
    </div>

  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import LoyaltySegment from '@/navs/LoyaltySegment';
  import ItemLoyaltyActivation from '@/items/ItemLoyaltyActivation';

  export default {
    name: 'LoyaltyActivations',
    components: { PageTitle, LoyaltySegment, ItemLoyaltyActivation },
    computed: {
      ...mapState({
        loading: state => state.loyalty.loading,
        activations: state => state.loyalty.activations,
      })
    },
    mounted() {
      this.$store.dispatch('loyalty/LOYALTY_ACTIVATIONS_REQUEST')
    }
  }
</script>